import React from 'react';
import logoOfficial from '../assets/logo-official.png';
import logoWhite from '../assets/logo-white.png';

/**
 * Konnectt Logo Component (PNG Version)
 * Uses high-quality official transparent assets for 100% design fidelity.
 * 
 * @param {string} size - 'small', 'medium', 'large'
 * @param {string} variant - 'dark' (default), 'light' (white version)
 * @param {string} className - Additional CSS classes
 */
export default function Logo({ size = 'medium', variant = 'dark', className = '' }) {
    // Proportional heights for the container (Bold zoom as requested)
    const heights = {
        small: 'h-28',
        medium: 'h-48',
        large: 'h-76'
    };

    const currentHeight = heights[size] || heights.medium;

    return (
        <div className={`flex items-center justify-center ${className} transition-transform duration-300 hover:scale-[1.02]`}>
            <img
                src={variant === 'light' ? logoWhite : logoOfficial}
                alt="Konnectt Logo"
                className={`${currentHeight} w-auto object-contain ${variant === 'light' ? 'mix-blend-screen brightness-110' : ''}`}
            />
        </div>
    );
}
